import { render, staticRenderFns } from "./UserMotivationDetailsSidebar.vue?vue&type=template&id=32b39c74&scoped=true&"
import script from "./UserMotivationDetailsSidebar.vue?vue&type=script&lang=js&"
export * from "./UserMotivationDetailsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserMotivationDetailsSidebar.vue?vue&type=style&index=0&id=32b39c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b39c74",
  null
  
)

export default component.exports